<template>
  <div class="product-container">
    <nav class="nav-header">
      <p
        @click="$router.push({ name: 'company-admin-dashboard' })"
        :class="$route.name === 'company-admin-dashboard' ? 'active' : ''"
      >
        Dashboard
      </p>
      <p
        @click="$router.push({ name: 'company-admin-daily-usage' })"
        :class="$route.name === 'company-admin-daily-usage' ? 'active' : ''"
      >
        Daily Usage
      </p>
      <!-- <p @click="$router.push({name: 'company-admin-weekly-usage'})"
         :class="($route.name === 'company-admin-weekly-usage') ? 'active' : ''">Weekly Usage</p> -->
    </nav>
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 15px 0px 15px;
    box-shadow: inset 0 1px 0 0 #f8f9fe;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
      margin-right: 10px;
      margin-bottom: 0;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
    //padding: 16px;
  }
}
</style>

